<div class="flex">
  <app-navbar [currentUser]="authService.getCurrentUser() | async" *ngIf="authService.getCurrentUser() | async"></app-navbar>
  <app-sidenav></app-sidenav>
</div>
